module.exports = __webpack_public_path__ + "static/media/10-rectangle-occupied.b8316401.svg";